import type { ReactNode } from 'react';
import styles from './Toolbar.module.css';

/**
 * Design system § 14 — Toolbar.
 *
 * The row above a table: what narrows the set at the start, what acts on the
 * whole set at the end. Layout and nothing else — every control inside it is
 * a primitive at `size="compact"` (§ 16), and this component does not style
 * them.
 *
 * A `search` landmark rather than a bare `<div>` of controls, so a screen
 * reader can jump to the filters and back out of them; the accessible name is
 * required for the same reason a table's caption is.
 */

interface ToolbarProps {
  /** The accessible name of the region — "Filtrar usuários". */
  label: string;
  /** Search and filters. They wrap before any of them shrinks. */
  children: ReactNode;
  /** What applies to the whole set, pinned to the end of the row. */
  actions?: ReactNode;
}

export function Toolbar({ label, children, actions }: ToolbarProps) {
  return (
    <search className={styles.toolbar} aria-label={label}>
      <div className={styles.filters}>{children}</div>
      {actions ? <div className={styles.actions}>{actions}</div> : null}
    </search>
  );
}
